import { fieldFragment } from '@/services/fragments/property'

export const getPropertyQuery = /* GraphQL */ `
  query GetProperty($id: ID!) {
    getProperty(id: $id) {
      id
      name
      version
      organization {
        id
        name
      }
      fields(limit: 10000) {
        items {
          id
        }
      }
    }
  }
`

export const getPropertyFieldsQuery = /* GraphQL */ `
  query GetPropertyFields($id: ID!, $lang: ModelTranslationFilterInput) {
    getPropertyFields(id: $id) {
      id
      field {
        id
        key
        label
        value
        type
        organizationFieldsId
        organization {
          id
          name
        }
        metadata {
          key
          value
          type
        }
        translations(filter: $lang, limit: 100) {
          items {
            id
            label
            lang
            updatedAt
          }
        }
        updatedAt
      }
    }
  }
`

export const getFieldQuery = /* GraphQL */ `
  query GetField(
    $id: ID!
    $lang: ModelTranslationFilterInput
    $optionFilter: ModelOptionFilterInput
  ) {
    getField(id: $id) {
      ...fieldItem
    }
  }
  ${fieldFragment}
`

export const getFieldOwnerQuery = /* GraphQL */ `
  query GetFieldOwner($id: ID!) {
    getField(id: $id) {
      id
      key
      label
      value
      type
      organizationFieldsId
      updatedAt
      organization {
        name
      }
    }
  }
`

export const listFieldsQuery = /* GraphQL */ `
  query ListFields(
    $filter: ModelFieldFilterInput
    $lang: ModelTranslationFilterInput
    $optionFilter: ModelOptionFilterInput
    $nextToken: String
  ) {
    listFields(filter: $filter, limit: 10, nextToken: $nextToken) {
      items {
        ...fieldItem
      }
      nextToken
    }
  }
  ${fieldFragment}
`

export const updateFieldMutation = /* GraphQL */ `
  mutation UpdateField($input: UpdateFieldInput!) {
    updateField(input: $input) {
      updatedAt
    }
  }
`

export const updateOptionMutation = /* GraphQL */ `
  mutation UpdateOption($input: UpdateOptionInput!) {
    updateOption(input: $input) {
      id
      status
      label
      value
      fieldOptionsId
      optionOptionsId
      updatedAt
    }
  }
`

export const createFieldMutation = /* GraphQL */ `
  mutation CreateField($input: CreateFieldInput!) {
    createField(input: $input) {
      createdAt
    }
  }
`

export const createPropertyFieldMutation = /* GraphQL */ `
  mutation CreateField(
    $createFieldInput: CreateFieldInput!
    $createPropertyFieldsInput: CreatePropertyFieldsInput!
  ) {
    createField(input: $createFieldInput) {
      createdAt
    }
    createPropertyFields(input: $createPropertyFieldsInput) {
      createdAt
    }
  }
`

export const createPropertyFieldsMutation = /* GraphQL */ `
  mutation CreatePropertyField($input: CreatePropertyFieldsInput!) {
    createPropertyFields(input: $input) {
      createdAt
    }
  }
`

export const createOptionMutation = /* GraphQL */ `
  mutation CreateOption($input: CreateOptionInput!) {
    createOption(input: $input) {
      id
      status
      label
      value
      fieldOptionsId
      optionOptionsId
      updatedAt
      createdAt
    }
  }
`

export const deleteFieldMutation = /* GraphQL */ `
  mutation DeleteField($input: DeleteFieldInput!) {
    deleteField(input: $input) {
      updatedAt
    }
  }
`

export const deletePropertyFieldsMutation = /* GraphQL */ `
  mutation DeletePropertyFields($input: DeletePropertyFieldsInput!) {
    deletePropertyFields(input: $input) {
      updatedAt
    }
  }
`

export const deleteOptionMutation = /* GraphQL */ `
  mutation DeleteOption($input: DeleteOptionInput!) {
    deleteOption(input: $input) {
      updatedAt
    }
  }
`

export const updateTranslationMutation = /* GraphQL */ `
  mutation UpdateTranslation($input: UpdateTranslationInput!) {
    updateTranslation(input: $input) {
      id
      lang
      label
      updatedAt
    }
  }
`

export const createTranslationMutation = /* GraphQL */ `
  mutation CreateTranslation($input: CreateTranslationInput!) {
    createTranslation(input: $input) {
      id
      lang
      label
      updatedAt
      createdAt
    }
  }
`

export const deleteTranslationMutation = /* GraphQL */ `
  mutation DeleteTranslation($input: DeleteTranslationInput!) {
    deleteTranslation(input: $input) {
      updatedAt
    }
  }
`
export const createPropertyMutation = /* GraphQL */ `
  mutation CreateProperty($input: CreatePropertyInput!) {
    createProperty(input: $input) {
      createdAt
    }
  }
`

export const updatePropertyMutation = /* GraphQL */ `
  mutation UpdateProperty($input: UpdatePropertyInput!) {
    updateProperty(input: $input) {
      updatedAt
    }
  }
`

export const deletePropertyMutation = /* GraphQL */ `
  mutation DeleteProperty($input: DeletePropertyInput!) {
    deleteProperty(input: $input) {
      updatedAt
    }
  }
`

export const fieldsByOrganizationQuery = /* GraphQL */ `
  query FieldsByOrganization(
    $organizationFieldsId: ID!
    $filter: ModelFieldFilterInput
    $lang: ModelTranslationFilterInput
  ) {
    fieldsByOrganization(
      organizationFieldsId: $organizationFieldsId
      filter: $filter
    ) {
      items {
        id
        key
        label
        value
        type
        organizationFieldsId
        updatedAt
        organization {
          name
        }
        translations(filter: $lang, limit: 10) {
          items {
            label
            lang
          }
        }
      }
    }
  }
`
